<template>
    <div class="animated fadeIn">
      <b-row>
        <b-col sm="12">
          <b-card header-tag="header" footer-tag="footer">
            <div slot="header">
              <strong>Approve Payment</strong>
            </div>
                
        <!-- code for tab -->
            <b-row>
              <b-col >
                    
              <div>
                <ul class="nav nav-tabs nav-justified">
                  <li class="nav-item">
                    <a @click="activeTab = 1;" class="nav-link" :class="{'active' : isActiveTab(1)}" >COD Collection Closure</a>
                  </li>

                  <li class="nav-item">
                    <a @click="activeTab = 2;" class="nav-link " :class="{'active' : isActiveTab(2)}">Expense Closure</a>
                  </li>
                  
                  <li class="nav-item">
                    <a @click="activeTab = 3;" class="nav-link " :class="{'active' : isActiveTab(3)}">Current status COD</a>
                  </li> 
                </ul>
              </div>
                        
              </b-col>
            </b-row>
            <component :is="currentComponent" class="mt-5"></component>
          </b-card>
        </b-col>
      </b-row>
    </div>
</template>

<script>
import COD_collectionApproval from './COD_collectionApproval.vue';
import expenseApproval from './expenseApproval.vue';
import currentStatusCOD from './currentStatusCOD.vue';

export default{
    components: {
      COD_collectionApproval,
      expenseApproval,
      currentStatusCOD
    },
    data: function(){
      return{
        activeTab: 1,
      }
    },
    created: function(){
        this.isActiveTab(1);
    },
    computed: {
        currentComponent(){
          console.log("this.activeTab----> ",this.activeTab);
            if(this.activeTab === 1)           
                return "COD_collectionApproval";
            else if(this.activeTab === 2)
                return "expenseApproval";
            else
                return "currentStatusCOD"
        }
    },
    methods: {
        isActiveTab(id)
        {
          return this.activeTab === id;
        },
    }
}

</script>

<style>

</style>